<template>
  <div class="body">
    <div class="search-box">
      <div class="search-img"></div>
      <form action="javascript:return true">
        <input type="search" v-model="inputText" @keypress="searchGoods" placeholder="输入医生 、疾病搜索"  @input="inputSearch"/>
        <div class="search-btn" @click="handleSearch">搜索</div>
      </form>
    </div>
    <div class="ji-search-list" v-if="searching">
      <ul class="search-ul">
        <li v-for="(item,index) in linsearchs" v-html="item.nameHighlights" @click="selectName(item.name)">

        </li>
      </ul>
    </div>
    <div class="doctor-list">
      <loadMore
        class="doctor-load-more"
        v-if="docList.length>0"
        :onLoadMore="onLoadMore"
        :enableLoadMore="enableLoadMore"
      >
        <ul class="hot-lists">
          <li
            v-for="(item,index) in docList"
            :key="index"
            @click="routePush('/doctor_main?doctorid='+item.id)"
          >
            <div class="dis-doc-left">
              <div class="item-expert">
                <p class="expert-avar">
                  <img :src="item.avatar" class="all-i" alt />
                </p>
              </div>
            </div>
            <div class="expert-info">
              <div class="item-expert font-85">
                <div class="expert-info-doctor">
                  <span class="expert-name">{{item.zname}}</span>
                  <span class="expert-pos">{{item.position}}</span>

                  <p class="hos-name">{{item.hospname}}</p>
                </div>
                <p class="expert-info-good" v-if="item.type ==3">问诊过</p>
              </div>
              <div class="item-dis good-hide">擅长：{{item.goodable}}</div>
            </div>
          </li>
        </ul>
      </loadMore>
      <div class="doc-default" v-if="docList.length==0">
        <img src="../../../static/icons/shuju@3x.jpg" alt />
        <div class="doc-default-txt font-85">暂无数据</div>
      </div>
    </div>
    <div class="search-list" v-show="tagboxshow">
      <div class="search-list-title font-85">热门医生</div>
      <div class="search-list-tag display_flex_start flex_wrap">
        <div
          class="tag-detail font-65"
          @click="searchDoctor(item.zname)"
          v-for="(item,index) in doctag"
          :key="index"
        >{{item.zname}}</div>
      </div>
      <div class="search-white"></div>
      <div class="search-list-title">按疾病</div>
      <div class="search-list-tag display_flex_start flex_wrap">
        <div
          class="tag-detail font-65"
          @click="searchDoctor(item.name)"
          v-for="(item,index) in distag"
          :key="index"
        >{{item.name}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "../../request/http";
import loadMore from "../loadMore";
export default {
  name: "search",
  data() {
    return {
      docList: [],
      inputText: "",
      distag: [],
      doctag: [],
      tagboxshow: true,
      img_src: "../../../static/icons/guanzhu_false@3x.png",
      img_src1: "../../../static/icons/guanzhu_true@3x.png",
      page: 1,
      enableLoadMore: true,
      searching:false,
      linsearchs:'',
      fun_timer:null
    };
  },
  components: {
    loadMore,
  },
  methods: {
    handleClear(){
      console.log(11)
    },
    // 关注
    handleToFav(id, type, index) {
      let data = {
        docid: id,
        fan_tag: +type,
      };
      http.post("/api/wap/doctor/fan", data).then((res) => {
        if (res.errno == 0) {
          this.docList.forEach((v, i) => {
            if (i == index) {
              v.type = type == 1 ? 2 : 1;
            }
          });
        }
      });
    },
    onLoadMore(done) {
      setTimeout(() => {
        if (!this.enableLoadMore) {
          return;
        }
        this.page = this.page + 1;
        this.searchDoctor("", () => {
          done();
        });
      }, 200);
    },
    selectName(cont){
      this.searchDoctor(cont);
    },
    searchGoods(e) {
      if (event.keyCode == 13) {
        event.preventDefault();
        this.page = 1;
        this.searchDoctor();
      }
    },
    searchDoctor(text, done = function () {}) {
      this.searching = false
      let cont;
      if (text) cont = text;
      else cont = this.inputText;
      http
        .post("/api/wap/doctor/search", { content: cont, pageIndex: this.page })
        .then((res) => {
          done();
          this.tagboxshow = false;
          if (res.data.length < 10) {
            this.enableLoadMore = false;
          }
          if (this.page == 1) {
            this.docList = res.data;
          } else {
            this.docList = this.docList.concat(res.data);
          }
        })
        .catch((err) => {
          done();
        });
    },
    distags() {
      http.post("/api/wap/public/distab").then((res) => {
        this.distag = res.data;
      });
    },
    doctags() {
      http.post("/api/wap/public/doctab").then((res) => {
        this.doctag = res.data;
      });
    },
    routePush(path) {
      this.$router.push(path);
    },
    handleSearch(){
      this.searchDoctor();
      // if(this.inputText&&this.inputText.trim()!= ''){
      //   this.debounce(this.linsearch,500)
      // }
    },
    inputSearch(){
      if(this.inputText&&this.inputText.trim()!= ''){
        this.debounce(this.linsearch,500)
      }
    },
    linsearch(){
      http.post('/api/wap/public/search',{
        content:this.inputText
      }).then(res=>{
        let conts = [];
        this.searching = true
        console.log(res);
        //conts.push(this.highlights(res.data))
        this.linsearchs = [];
        this.highlights(res.data)
        console.log(this.linsearchs)
      })
    },
    highlights(jsons) {
      const search = this.inputText
      jsons.map(item => {
        for (let key in item) {
          let replaceReg = new RegExp(search, 'g')// 匹配关键字正则
          let replaceString = '<span class="highlights-text">' + search + '</span>' // 高亮替换v-html值
          item[key + 'Highlights'] = item[key].replace(replaceReg, replaceString) // 开始替换
          this.linsearchs.push(item)
        }
      })
    },
    debounce(fn,delay){
      if(this.fun_timer){
        clearTimeout(this.fun_timer)
      }
      this.fun_timer = setTimeout(fn,delay)
    },
  },
  mounted() {
    this.distags();
    this.doctags();
  },
  destroyed () {
    if(this.fun_timer){
      clearTimeout(this.fun_timer)
      this.fun_timer = null
    }
  }
};
</script>

<style scoped>
@import "../index/index.css";
.search-box {
  height: 3rem;
  box-sizing: border-box;
  padding: 1rem 1rem 0;
  position: relative;
}
.body {
  padding: 0;
  position: relative;
  background: #fff;
}
.search-list {
  width: 100%;
  background: #fff;
  box-sizing: border-box;
  position: absolute;
  top: 4rem;
  left: 0;
  z-index: 100;
  height: calc(100vh - 3.5rem);
  overflow-x: hidden;
  overflow-y: auto;
}
.search-list-title {
  width: 100%;
  height: 1.3rem;
  line-height: 1.3rem;
  font-size: 0.9rem;
  padding: 0 1rem;
  box-sizing: border-box;
  background: #fff;
}
.search-list-tag {
  width: 100%;
  padding: 0 1rem 1rem;
  box-sizing: border-box;
  background: #fff;
}
.tag-detail {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 1.4rem;
  font-size: 0.7rem;
  padding: 0 0.45rem;
  box-sizing: border-box;
  border-radius: 0.7rem;
  background-color: rgba(0, 0, 0, 0.04);
  margin: 1rem 0.8rem 0 0;
  color: rgba(0,0,0,0.65);
}
.ji-search-list{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 4rem;
  left: 0;
  z-index: 999;
  background: #fff;
}
.search-white {
  width: 100%;
  height: 1rem;
  background: #fff;
}
.display_flex_start {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.flex_wrap {
  flex-wrap: wrap;
}
.search-img {
  width: 1rem;
  height: 1rem;
  position: absolute;
  top: 1.5rem;
  background: url("../../../static/icons/search11@3x.png") no-repeat;
  background-size: 100% 100%;
  z-index: 99;
  left: 1.6rem;
}
input[type="search"]::-webkit-search-cancel-button {
  -webkit-appearance: none;
  position: absolute;
  height: 1rem;
  width: 1rem;
  background: url("../../../static/icons/clean3x.png")
    no-repeat;
  background-size: 100% 100%;
  top: 50%;
  right: 0.6rem;
  margin-top: -0.5rem;
}
input[type="search"] {
  padding-right: 1.6rem;
  padding-left: 1.85rem;
  padding: 0.45rem 1.6rem 0.45rem 1.85rem;
  position: relative;
  width: 14.55rem;
  height: 2rem;
  border-radius: 1rem;
  background: #FAFAFA;
  border:0.05rem solid #E8E8E8;
  font-size: 0.7rem;
  line-height: 1.1rem;
  color: rgba(0,0,0,0.85);
  box-shadow:none; /*去除阴影*/
  outline: none;/*聚焦input的蓝色边框*/
  resize: none; /*textarea 禁止拖拽*/
  -webkit-appearance: none;/*常用于IOS下移除原生样式*/
}
input[type="search"]::placeholder{
  font-size: 0.7rem;
  line-height: 1.1rem;
  color: rgba(0,0,0,0.25);
}
.doc-default {
  width: 100%;
  height: calc(100vh - 3.5rem);
  background: #fff;
}
.doc-default img {
  width: 15.9rem;
  height: 11rem;
  vertical-align: top;
  margin-left: calc(50% - 7.95rem);
}
.doc-default-txt {
  width: 100%;
  height: 1.2rem;
  margin-top: 0.5rem;
  line-height: 1.2rem;
  font-size: 0.8rem;
  text-align: center;
}
.doctor-list {
  width: 100%;
  height: calc(100vh - 3rem);
  position: relative;
}
.doctor-load-more {
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  transition-duration: 300ms;
}
  form{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .search-btn{
    font-size: 0.7rem;
    color: rgba(0,0,0,0.45);
  }
  .search-ul li{
    width: 100%;
    height: 2.85rem;
    padding: 0.75rem 1rem;
    font-size: 0.9rem;
    color: rgba(0,0,0,0.85);
    border-bottom: 0.05rem solid rgba(0,0,0,0.09);
    line-height: 1.3rem;
  }
.hot-lists{
  padding: 0;
}
.hot-lists li{
  padding:1rem;
  border-bottom:0.025rem solid rgba(0,0,0,0.09);
}
  .dis-doc-left{
    width: 2rem;
  }
.hot-lists .expert-avar{
  width: 2rem;
  height: 2rem;
}
.all-i{
  height: 100%;
}
  .expert-info{
    padding-left: 0.6rem;
  }
  .expert-name{
    font-size: 0.9rem;
    color: rgba(0,0,0,0.85);
    line-height: 1.3rem;
  }
  .expert-pos{
    font-size: 0.7rem;
    color: rgba(0,0,0,0.85);
  }
  .hos-name{
    font-size: 0.7rem;
    color: rgba(0,0,0,0.85);
    line-height: 1.1rem;
    margin-top: 0.2rem;
  }
.hot-lists .item-dis.good-hide {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.hot-lists .item-dis.good-hide{
  font-size: 0.7rem;
  color: rgba(0,0,0,0.65);
  line-height: 1.1rem;
}
  .expert-info-good{
    width: 2.5rem;
    height: 1rem;
    background: #E6F7FF;
    color: #1890FF;
    line-height: 1rem;
    text-align: center;
    padding: 0;
    border-radius: 0.15rem;
  }
.hot-lists .item-dis{
  margin-top: 0.4rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/search/search.vue